var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s_p_img",on:{"click":function($event){return _vm.runShare('twitter')}}},[_c('img',{attrs:{"src":require("@/assets/image/icon/iconX.png")}}),_c('div',{staticClass:"s_p_img_text"},[_vm._v(" X ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }